// Libs
import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
// Components, Layouts, Pages
import { Logo, ProductTable, Space } from '~/components/module/pdf';
import { HeaderPayrollPdf } from '~/components/module/payroll';
import { IColTablePdf } from '../../pdf/productTable/ProductTable';
// Others
import { IDataExportPayroll, IPayrollExportHour } from '~/utils/interface/payroll';
import { DEFAULT_CURRENCY, EMPTY_STRING } from '~/utils/constants/common';
import { formatCurrency } from '~/utils/helper/common';
// Styles, images, icons

type Props = {
  data: IDataExportPayroll;
};

const PdfPayroll = (props: Props) => {
  //#region Destructuring Props
  const { data } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const columns = (): IColTablePdf<IPayrollExportHour>[] => {
    return [
      {
        key: 'no',
        title: 'No',
        render(_, index) {
          return <Text>{index + 1}</Text>;
        },
        width: 200,
      },
      {
        key: 'fullName',
        title: 'Employee',
        render(record, index) {
          return <Text>{record.fullName || EMPTY_STRING}</Text>;
        },
        width: 800,
      },
      {
        key: 'hours',
        title: 'Hours',
        render(record, index) {
          return <Text>{record.hours || EMPTY_STRING}</Text>;
        },
        width: 250,
      },
      {
        key: 'rate',
        title: 'Hourly Rate',
        render(record, index) {
          return <Text>{record.rate ? formatCurrency(record.rate) : EMPTY_STRING}</Text>;
        },
      },
      {
        key: 'commissionOnJob',
        title: 'Commission',
        render(record, index) {
          return (
            <Text>{record.commissionOnJob ? formatCurrency(record.commissionOnJob) : DEFAULT_CURRENCY}</Text>
          );
        },
      },
      {
        key: 'totalPay',
        title: 'Total',
        render(record, index) {
          return <Text>{record.totalPay ? formatCurrency(record.totalPay) : DEFAULT_CURRENCY}</Text>;
        },
      },
    ];
  };
  //#endregion Handle Function

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.container}>
          <View style={styles.viewHeader}>
            <Logo />

            <HeaderPayrollPdf month={data.month} />
          </View>

          <Space height={20} />

          <ProductTable columns={columns()} data={data.data} />

          <View style={styles.viewFooter}>
            <Text style={styles.textFooter}>
              Thank you for choosing Noble Plumbing to take care of all your plumbing needs.
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PdfPayroll;

const styles = StyleSheet.create({
  page: {
    paddingTop: 60,
    paddingLeft: 40,
    paddingRight: 40,
    paddingBottom: 40,
    flexDirection: 'column',
    gap: 40,
    fontWeight: 400,
    fontSize: 10,
  },
  container: {
    flex: 1,
  },
  viewHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 40,
    height: 100,
  },
  viewFooter: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  textFooter: {
    color: '#63667A',
    fontSize: 12,
  },
});
